/**
 * AppIdeDefault bond setup
 *
 * Wires @molecule/app-ide-default to @molecule/app-ide
 */

import { setProvider } from '@molecule/app-ide'
import { provider } from '@molecule/app-ide-default'

export function setupAppIdeDefault(): void {
  setProvider(provider)
}
